import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: "adapt-incomplete-work",
    templateUrl: "./incomplete-work.component.html",
    styleUrl: "./incomplete-work.component.css",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class IncompleteWorkComponent {
    @Input() public message?: string;
}
